import { render, staticRenderFns } from "./usuarios_especiales.vue?vue&type=template&id=3fcb012a"
import script from "./usuarios_especiales.vue?vue&type=script&lang=js"
export * from "./usuarios_especiales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports